/*
 * Cart gift guard
 *
 * The bundle app hands out "Free Shipping" and "Shipping Protection" as real
 * products, priced £3.95 and £1.99, discounted to £0.00 while the Buy 3 tier
 * applies. Drop back to two items and the discount goes away, but the two line
 * items stay — so the customer is silently charged £5.94 for gifts they were
 * given. This removes any gift line the moment it stops being free.
 *
 * Which products count as gifts comes from Theme settings -> Cart -> Free
 * gifts, matched on handle or title.
 *
 * Config is rendered outside .drawer__inner so it survives the drawer's
 * innerHTML swap, and this file is loaded once rather than re-run per render.
 */
(function () {
  const configEl = document.getElementById('ShapssGiftGuard');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!config.enabled || !Array.isArray(config.names) || !config.names.length) return;

  const names = config.names.map((n) => String(n).trim().toLowerCase()).filter(Boolean);
  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';

  // A sweep can trigger a cart update, which would call the next sweep. The
  // flag stops the overlap and the pass counter stops a pathological loop if
  // the server ever refuses to drop the line.
  let busy = false;
  let passes = 0;
  const MAX_PASSES = 6;

  function isGift(item) {
    const handle = String(item.handle || '').toLowerCase();
    const title = String(item.product_title || item.title || '').toLowerCase();
    return names.indexOf(handle) !== -1 || names.indexOf(title) !== -1;
  }

  function sectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].filter((id) =>
      document.getElementById(id === 'cart-drawer' ? 'CartDrawer' : id)
    );
  }

  function paint(sections) {
    if (!sections) return;

    const targets = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'main-cart-items', section: 'main-cart-items', selector: '.js-contents' },
      { id: 'main-cart-footer', section: 'main-cart-footer', selector: '.js-contents' },
    ];

    targets.forEach((target) => {
      const container = document.getElementById(target.id);
      const html = sections[target.section];
      if (!container || !html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(target.selector);
      if (!parsed) return;

      const elementToReplace = container.querySelector(target.selector) || container;
      elementToReplace.innerHTML = parsed.innerHTML;
    });
  }

  function removeLine(key, withSections) {
    const body = {
      id: key,
      quantity: 0,
    };
    if (withSections) {
      body.sections = sectionsToRender();
      body.sections_url = window.location.pathname;
    }

    return fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((response) => response.json());
  }

  function sweep() {
    if (busy || passes >= MAX_PASSES) return Promise.resolve();
    busy = true;

    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const stale = (cart.items || []).filter((item) => isGift(item) && item.final_line_price > 0);
        if (!stale.length) {
          passes = 0;
          return null;
        }

        passes += 1;

        // Removed one at a time because every removal reindexes the cart; only
        // the last call asks for sections, so the drawer repaints once.
        return stale.reduce(
          (chain, item, index) =>
            chain.then(() => removeLine(item.key, index === stale.length - 1)),
          Promise.resolve()
        );
      })
      .then((state) => {
        if (state && state.sections) paint(state.sections);
        if (state && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // source 'cart-items' so cart.js does not repaint on top of us.
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
        }
      })
      .catch(() => {})
      .finally(() => {
        busy = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Let the cart settle before reading it back.
      setTimeout(sweep, 60);
    });
  }

  // The cart may already hold a stale gift from an earlier visit.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();
